import type { InitConfig, SdkMessage, MessageType, ResignRequest } from '@solidgate/react-sdk';
import type { IOrderExtended, IOrderCreateResponse } from '@/types/order';

/**
 * Order & Extra order
 */
export type PaymentVariant = 'order' | 'extraSnapshot';

export enum PaymentGatewayProvider {
  Paycore = 1,
  Solidgate = 2,
}

// Paycore
// -- payment page redirect
export type PaycoreRequestPaymentResponse = {
  url: string; // URL to redirect the user to for payment
};

// Solidgate payment types
// -- form
export type SolidgatePaymentDetails = SdkMessage[MessageType.PaymentDetails];
export type SolidgatePaymentPriceBreakdown = SolidgatePaymentDetails['payment']['priceBreakdown'];
export type SolidGateMerchantData = Omit<InitConfig['merchantData'], 'version'>;

export type SolidgateRequestPaymentResponse = {
  // Payment form
  paymentForm: {
    idPayment: string; // required for status check
    update: SolidgatePaymentFormUpdate; // Partial update
    merchantData: SolidGateMerchantData;
  };
  // Resign form
  resignPaymentForm?: {
    idPayment: string; // required for status check
    merchantData: ResignRequest;
  };
};

export type SolidgatePaymentFormUpdate = {
  partialIntent: string;
  signature: string;
} | null;

export type SolidgatePaymentModalRequirements = { paymentDetails: SolidgateRequestPaymentResponse; order: PaymentOrder };

export type SolidgatePaymentStatusResponse = {
  id: SolidgatePaymentStatus;
  status: 'Fail' | 'Success' | 'Pending';
};

export type SolidgatePaymentModalStatus = Partial<{
  id: SolidgatePaymentStatus;
  code: string; // Optional error code
  idOrder: number; // Optional order id
}>;

export enum SolidgatePaymentStatus {
  Pending = 1,
  Success,
  Failed,
}

/**
 * Represent the order data that is needed for payment processing.
 */
export type PaymentOrder = (Pick<IOrderExtended, 'snapshot' | 'sandboxSnapshot'> | IOrderCreateResponse) & { id: number };

export type SolidgatePaymentCardDetails = {
  id: string;
  number: string;
  brand: string;
  cardType: string;
  cardExpYear: string;
  cardExpMonth: string;
  isPrimary: boolean; // Flag to indicate if the card is primary
};
